import Vue from "vue";
import Vuex from "vuex";
import createPersistedState from "vuex-persistedstate";
Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    // 用户信息
    userInfo: {},
    // 购物车数量
    shopCarCount: 0,
    bookTypeList: [],
    // token
    token: '',
    // 运行环境 H5 | PC | 微信H5
    runEnv: 1,
    // 页面尺寸 > 768px(是否显示移动端UI)
    showMobileComponent: false,
  },
  plugins: [createPersistedState()],
  mutations: {
    setUserInfo(state, payload) {
      state.userInfo = payload;
    },
    changeMobileComponent(state, payload) {
      state.showMobileComponent = payload;
    },
    changeShopCarCount(state, payload) {
      state.shopCarCount = payload;
    },
    changeBookTypeList(state, payload) {
      state.bookTypeList = payload;
    },
    setToken(state, payload) {
      state.token = payload;
    },
  },
  actions: {
    updateUserInfo({ commit }, payload) {
      // 1. 发异步请求, 请求数据

      // 2. commit调用mutation来修改/保存数据

      commit("setUserInfo", payload);
    },
  },
  modules: {},
});
